import * as React from 'react';
import { TextField } from '@material-ui/core';
import { IIdNamePair } from '../../services/ResourceRelationsService';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function AuthorizationLevelAutocomplete(props: {
	value: IIdNamePair,
	onSelect: (value: IIdNamePair) => void,
	options: IIdNamePair[],
}) {

	const [inputValue, setInputValue] = React.useState('');

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
	};

	const filter = (data: IIdNamePair[]): IIdNamePair[] => {
		return data.filter(x => x.name.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) > -1)
	};

	return (
		<Autocomplete
			fullWidth
			className="mi-lab-autocomplete-outlined"
			value={props.value}
			onChange={(event, newValue) => {
				let nv = newValue as IIdNamePair;
				props.onSelect(nv);
			}}
			getOptionLabel={(option: IIdNamePair) => option.name}
			options={props.options}
			filterOptions={filter}
			autoComplete
			includeInputInList
			
			renderInput={params => (
				<TextField
					{...params}
					variant="outlined"
					fullWidth
					onChange={handleChange}
					InputProps={{
						...params.InputProps,
						autoComplete: 'disabled',
						
						endAdornment: (
							<React.Fragment>
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					}}
				/>
			)}

			renderOption={(option: IIdNamePair) => {
				return (
					<div className="role-permission-option">
						{option.name}
					</div>
				);
			}}

		/>
	);
}